import { useEffect } from 'react'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Dashboard from '../Dashboard'
import { ABILITIES } from '../../components/Can'
import { getLastPartOfUrl } from '../../helpers/helpers'

const Organisation = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const userData = useSelector((state) => state.userData)

  useEffect(() => {
    const role = userData?.user?.role
    if (!ABILITIES.Navbar.organisation.includes(role)) {
      navigate('/')
    }
  }, [userData, navigate])

  const currentLocation = getLastPartOfUrl(location.pathname)

  return (
    <Dashboard.Container className={`ctp-organisation ctp-organisation--${currentLocation}`}>
      <div className="ctp-organisation__inner">
        <Outlet />
      </div>
    </Dashboard.Container>
  )
}

export default Organisation
